const global = window

inputs.fn.selectTable = {
    select(input, rowOrVal) {
        let row;
        if (typeof rowOrVal === 'object' && rowOrVal.length) {
            row = rowOrVal;
        } else {
            row = input.find('tbody > tr[data-value="' + rowOrVal + '"], tbody > tr[data-id="' + rowOrVal + '"]');
        }
        if (row && row.length) {
            if (row.hasClass('title') || row.hasClass('sectionTR') || row.hasClass('table__row--title')) {
                return;
            }
            input.find('tr.selected').removeClass('selected');
            row.addClass('selected');
            input.trigger('change');
        }
    },
    update(input, data, inputData, response) {
        input.find('tbody').html('');
        $.each(response.data, function(key, value) {
            let row = $('<tr class="table__row" data-id="'+value[0]+'" data-value="'+value[0]+'">')
            let cell = $('<td class="cell cell--cell cell table__cell"><span class="cell__wrap"><span class="icon ico" data-ico="' + value[2] + '"></span><span class="cell__info info">' + value[1] + '</span></span></td>')
            row.append(cell)
            input.find('tbody').append(row)
        })
        inputs.fn.selectTable.init(input);
        input.trigger('reloaded');
    },
    init(input) {
        input.off('click.selectTable', 'tr').on('click.selectTable', 'tr', function () {
            const rowVal = $(this).attr('data-value') || $(this).attr('data-id') || $(this).data('value') || $(this).data('id');
            if ($(this).hasClass('title') || $(this).hasClass('sectionTR') || $(this).hasClass('table__row--title') || rowVal === undefined || rowVal === null || rowVal === '') {
                return;
            }
            inputs.fn.selectTable.select(input, $(this));
        });
        if (input.find('tr.selected').length) {
            input.closest('.table__wrap').animate({
                scrollTop: input.find('tr.selected').position().top -40
            }, 500)
        }
    }
}

inputs.types.selectTable = function (data, name, niceName, type, input, parent, inputWindow) {
    inputs.fn.selectTable.init(input);
    data.update = function(inputData, response) {inputs.fn.selectTable.update(input, data, inputData, response)}

    return data
}
